import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import PageLoader from '../components/PageLoader';
import PrivateRoute from '../components/PrivateRoute';
import Metrics from '../pages/api-metrics';
import Health from '../pages/health';
import SLO from '../pages/slo';
import LogData from '../pages/logData';
import Traces from '../pages/traces';
import TMobile from '../pages/tMobile/tMobile';

const AppRoutes = () => {

    return (
      <Suspense fallback={<PageLoader />}>
        <Routes>
        <Route path="/" element={<Navigate to="/health" />} />
            <Route path="/health" element={<Health />} />
            <Route path="/metrics" element={<PrivateRoute><Metrics /></PrivateRoute>} />
            <Route path="/slo" element={<PrivateRoute><SLO /></PrivateRoute>} />
            <Route path="/logs" element={<PrivateRoute><LogData/></PrivateRoute>}/>
            <Route path="/traces" element={<PrivateRoute><Traces/></PrivateRoute>}/>
            <Route path="/tmobile" element={<PrivateRoute><TMobile/></PrivateRoute>}/>
        </Routes>
      </Suspense>
    )
}

export default AppRoutes;
